import EventEmitter from "eventemitter3";
import { ItemNode } from "./components/grid/ItemNode";
import { AppData, Log, Router } from "@lightningjs/sdk";
import { AppSetup } from "./app-setup";
import { Logger } from "./logger";
import { fetchData, getBlocksUrl, getUnblocksUrl } from "./models/data-service";
import AppModel from "./models/app-model";
import { DIALOG_BUTTON_ACTION, DIALOG_TYPE } from "./enum";
import { IDialogueInfo } from "./interfaces";

export default class BlockingManager extends EventEmitter {

    isItemBlocked = (videoData: ItemNode) => {
        const { appState } = AppData as AppSetup;
        const appApiConfig = appState?.getAppApiConfig();
        if (!appApiConfig?.appConfig.enableBlockFeature) {

        }
        if (videoData && videoData.blockItem) {
            return true;
        }
        return false;
    }

    isAdultRating(rating: string) {
        switch (rating) {
            case "18+":
            case "R":
            case "TV-MA":
                return true
            default:
                return false
        }
    }

    isAgeBlocked = (videoData: ItemNode) => {
        const { appConfig } = AppData as AppSetup
        if (appConfig?.enableSimpleAgeRatingDialog && this.isAdultRating(videoData.age_appropriate_rating) && !appConfig.isAgePopupShown) {
            appConfig.isAgePopupShown = true
            return true
        }
        return false
    }

    checkAndShowAgeRatingPopup(videoData: ItemNode, callback?:any) {
        if (this.isAgeBlocked(videoData)) {
            const dialogInfo: IDialogueInfo = {
                title: 'Confirm',
                body: 'Please confirm if you are 18+ ?',
                type: DIALOG_TYPE.APP_EXIT_BOX,
                buttons: [
                    {
                        name: 'No',
                        index: 0,
                        action: DIALOG_BUTTON_ACTION.NO,
                        initialFocus: true,
                    },
                    {
                        name: 'Yes',
                        index: 1,
                        action: DIALOG_BUTTON_ACTION.YES,
                        initialFocus: false
                    }
                ]
            }
            if(callback) {
                dialogInfo.callback = callback
                dialogInfo.callbackData = videoData
            }
            const page:any = Router.getActivePage()
            page.widgets.dialog.showDialog(dialogInfo)
            Router.focusWidget('dialog')
            return true
        } else {
            return false
        }
    }

    showBlockedNotification() {
        const page: any = Router.getActivePage()
        page.widgets.notification.showMessage('')
    }

    updateGridNodes(grid, nodeItem, action) {
        //fix for update the nodes for block/unblock items in parent rows.
        grid._updateRowNodes(nodeItem, action);
        if (grid.parentGrid !== null) {
            grid.parentGrid._updateRowNodes(nodeItem, action);
        }
        const { appState } = AppData as AppSetup;
        const app: AppModel = appState?.getApp()!;
        if (app.isTopCarouselVisible) {
            app.topCarouselGrid._updateRowNodes(nodeItem, action);
        }
    }

    doAction(actionType: string, category = null) {
        Log.info('BlockingManager: ', 'block doAction: ', actionType);
        let grid = null;
        let nodeInfo: ItemNode;
        let itemId;
        let contentType;
        let itemName;
        if (!category) {
            const { appState } = AppData as AppSetup;
            const app: AppModel = appState?.getApp()!;
            grid = app.navigation.getCurrentGrid();
            nodeInfo = grid.getFocusedItem();
            if (nodeInfo.type == 'listoflist') {
                itemId = (nodeInfo.node_id == '' ? nodeInfo.id : nodeInfo.node_id);
                contentType = nodeInfo.type;
                itemName = nodeInfo.title;
            } else {
                itemId = nodeInfo.node_id;
                contentType = nodeInfo.type;
                itemName = nodeInfo.title;
            }
        } else {
            const channel = category.channel
            itemId = channel.category_id;
            contentType = 'category';
            itemName = channel.name;
        }

        //const itemStr = `&itemId=${itemId}&contentType=${contentType}`;
        let apiUrl = '';
        if (actionType == 'block') {
            Logger.processUserAction('blockFeature_Block_' + itemName + '_' + contentType, itemId);
            apiUrl = getBlocksUrl(itemId, contentType);
        } else if (actionType == 'unblock') {
            Logger.processUserAction('blockFeature_Unblock_' + itemName + '_' + contentType, itemId);
            apiUrl = getUnblocksUrl(itemId, contentType);
        }

        //loaderComponent.showLoader();
        fetchData(apiUrl)
            .then(response => {
                const data = response.data;
                Log.info('blockingManager: doAction response: ' + actionType + ' data: ', data);
                if (data.status == 1) {
                    Log.info('blockingManager: updateElemStatus: itemId, contentType, actionType: ', itemId + ' ' + contentType + ' ' + actionType);
                    if (actionType == 'block') {
                        if (!category) {
                            this.updateGridNodes(grid, nodeInfo, actionType)
                        }
                        this.emit('blocked')
                    } else {
                        if (!category) {
                            this.updateGridNodes(grid, nodeInfo, actionType)
                        }
                        this.emit('unblocked')
                    }
                    //this.updateNodeStatus(itemId, contentType, actionType, focusDepth, focusedMenu);
                }
            });
    }

}
